import { getApiUrl } from './getApiUrl';
import { getUser, isAuthenticated } from '../auth/auth';

export type ActivityAction = 'launch_app' | 'start_test' | 'end_test' | 'download_result' | 'change_language' | 'analyze_results' | 'email_result';

const SESSION_ID_KEY = 'hearing_session_id';
const LAUNCH_SENT_KEY = 'hearing_launch_sent';

export function getSessionId(): string {
  let id = sessionStorage.getItem(SESSION_ID_KEY);
  if (!id) {
    id = crypto.randomUUID();
    sessionStorage.setItem(SESSION_ID_KEY, id);
  }
  return id;
}

export const logActivity = (action: ActivityAction, page?: string, description?: string, idtonalresult?: number | null): void => {
  if (action === 'launch_app') {
    if (sessionStorage.getItem(LAUNCH_SENT_KEY)) return;
    sessionStorage.setItem(LAUNCH_SENT_KEY, '1');
  }
  const user = isAuthenticated() ? getUser() : null;
  // logged-in users with portal_log=false opt out of activity tracking
  if (user && user.parameters?.['portal_log']?.value === false) return;
  const body = JSON.stringify({
    action,
    iduser:       user?.iduser ?? null,
    web_agent:    navigator.userAgent,
    page:         page ?? window.location.pathname,
    description:  description ?? null,
    idtonalresult: idtonalresult ?? null,
    session_id:   getSessionId(),
  });

  // fire-and-forget — use sendBeacon when available for reliability on page unload
  if (navigator.sendBeacon) {
    const blob = new Blob([body], { type: 'application/json' });
    navigator.sendBeacon(getApiUrl('tools/log-activity'), blob);
  } else {
    fetch(getApiUrl('tools/log-activity'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
    }).catch(() => { /* ignore */ });
  }
};
